import { getClassList, getProductList } from "@/api";
import { Empty, Input } from "antd";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import logo from "@/assets/logo.png";
export default function Home() {
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [total, setTotal] = useState(0);
  const [classList, setClassList] = useState<any[]>([]);
  const [productList, setProductList] = useState<any[]>([]);
  const [twoClassList, setTwoClassList] = useState<any[]>([]);
  const [index, setIndex] = useState(null);
  const [twoIndex, setTwoIndex] = useState(0);
  const [classId, setClassId] = useState(null);
  const [search, setSearch] = useState(null);
  const getClassListFun = () => {
    getClassList({ type: 1 }).then((res) => {
      setClassList(res.list || []);
      // if (res.list[0]) {
      //   setTwoClassList(res.list[0].children || []);
      // }
    });
  };

  const getProductListFun = (isSearch: boolean) => {
    getProductList({
      classId: isSearch ? null : classId,
      pageNo,
      pageSize,
      search,
    }).then((res) => {
      setTotal(res.total || 0);
      setProductList(productList.concat(res.list));
    });
  };

  const classChange = (index: any) => {
    setIndex(index);
    let list = classList[index]?.children || [];
    setTwoClassList(list);
    setProductList([]);
    setPageNo(1);
    setTwoIndex(0);
    setClassId(list[0]?.id || 0);
    setProductList([]);
  };

  useEffect(() => {
    getClassListFun();
  }, []);

  useEffect(() => {
    getProductListFun(false);
  }, [classId, pageNo, pageSize]);

  useEffect(() => {
    if (search) {
      getProductListFun(true);
    }
  }, [search]);

  const nextFun = () => {
    setPageNo(pageNo + 1);
  };

  const onSearch = (e: any) => {
    setPageNo(1);
    setProductList([]);
    setSearch(e);
  };

  const twoClassChange = (index: number) => {
    setClassId(twoClassList[index]?.id);
    setPageNo(1);
    setTwoIndex(index);
    setProductList([]);
  };
  return (
    <div>
      <div className="max-w-[1200px] mx-auto mt-[30px]">
        <div className="w-[340px] mx-auto">
          <img src={logo} />
        </div>
        <div className="px-[30px]">
          {/* 一级导航 */}
          <div className="flex flex-wrap">
            <div
              className={[
                "mr-[30px] cursor-pointer",
                index === null ? "font-bold" : "",
              ].join(" ")}
              onClick={() => {
                setClassId(null);
                setPageNo(1);
                setProductList([])
                setIndex(null);
                setTwoClassList([])
              }}
            >
              全部
            </div>
            {classList.map((item: any, number) => (
              <div
                key={item.id}
                className={[
                  "mr-[30px]",
                  "cursor-pointer",
                  index === number ? "font-bold" : "",
                ].join(" ")}
                onClick={() => {
                  classChange(number);
                }}
              >
                {item.name}
              </div>
            ))}
          </div>
          <div className="flex mt-[20px] justify-between items-center flex-wrap">
            {/* 二级导航 */}
            <div className="flex leading-[34px] flex-wrap">
              {twoClassList.map((item: any, number: number) => (
                <div
                  key={item.id}
                  className={[
                    "mr-[30px]",
                    "cursor-pointer",
                    twoIndex === number ? "font-bold" : "",
                  ].join(" ")}
                  onClick={() => {
                    twoClassChange(number);
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
            <div>
              <Input.Search
                enterButton={false}
                onSearch={onSearch}
              ></Input.Search>
            </div>
          </div>
          {/* <div className="text-[30px] mt-[30px]">狂欢盛典75折</div>
          <div className="text-[18px]">甄选好物限时优惠</div> */}
          {productList.length > 0 ? (
            <InfiniteScroll
              dataLength={productList.length}
              hasMore={productList.length < total}
              endMessage={<div className="text-center">已经到底部了</div>}
              next={() => {
                nextFun();
              }}
              loader={<div className="text-center">加载中...</div>}
            >
              <div className="flex flex-wrap">
                {productList.map((item) => {
                  return (
                    <div
                      className="xl:w-[25%] lg:w-[33%] md:w-[50%]"
                      key={item.id}
                    >
                      <div className="m-[20px] lg:text-[14px] text-[20px] text-[#666]">
                        <div>
                          <img src={item.imgUrl} alt="" />
                        </div>
                        <div>{item.title}</div>
                        <div className="font-bold text-[#000]">
                          {item.enTitle}
                        </div>
                        <div className="mt-[7px]">{item.desc}</div>
                        <div className="mt-[30px]">￥{item.price}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </InfiniteScroll>
          ) : (
            <div className="mt-[100px]">
              <Empty></Empty>
            </div>
          )}
        </div>
      </div>
      <div className="bg-[#f6f6f6]">
        <div className="max-w-[1200px] mx-auto mt-[30px] pt-[30px] pb-[30px] flex justify-between">
          <div className="text-[14px]">
            <div className="text-[#000] font-bold leading-6">珈白丽</div>
            <a href="http://angeperle.com/?pages_15/">
              <div className="text-[#666] leading-6">专业建议</div>
            </a>{" "}
            <a href="http://angeperle.com/?pages_15/">
              <div className="text-[#666] leading-6">客户服务</div>
            </a>{" "}
            <a href="http://angeperle.com/?pages_15/">
              <div className="text-[#666] leading-6">加盟我们</div>
            </a>
          </div>
          <div className="text-[14px]">
            <div className="text-[#000] font-bold leading-6">新闻中心</div>
            <a href="http://angeperle.com/?pages_10/">
              <div className="text-[#666] leading-6">活动</div>
            </a>{" "}
            <a href="http://angeperle.com/?pages_11/">
              <div className="text-[#666] leading-6">百科</div>
            </a>{" "}
            <a href="http://angeperle.com/?pages_12/">
              <div className="text-[#666] leading-6">公益</div>
            </a>
          </div>
          <div className="text-[14px]">
            <div className="text-[#000] font-bold leading-6">服务</div>
            <a href="http://angeperle.com/?pages_10/">
              <div className="text-[#666] leading-6">专业建议</div>
            </a>
            <a href="http://angeperle.com/?pages_15/">
              <div className="text-[#666] leading-6">客户服务</div>
            </a>
            <a href="http://angeperle.com/?pages_15/">
              <div className="text-[#666] leading-6">加盟我们</div>
            </a>
          </div>
          <div>
            <div className="text-[18px]">订阅珈白丽最新讯息</div>
            <Input placeholder="请输入电子邮件" className="mt-[10px]"></Input>
            <button className="mt-[10px] w-[120px] h-[40px] bg-[#000] text-[#fff] text-[14px]">
              提交
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
